<script setup lang="ts">
import { computed } from 'vue';
import type { CoursePassRate } from '@/types/PassRateReport';

const props = defineProps<{
    useFullWidth: boolean,
    coursePassRate: CoursePassRate,
}>();

const labelRowClasses = props.useFullWidth ? 'col-4' : 'col-8';
const dataRowClasses = props.useFullWidth ? 'col-8' : 'col-4';
const firstTryPassRate = computed(() => (props.coursePassRate.firstTryPassRate ? `${props.coursePassRate.firstTryPassRate}%` : '--'));
</script>
<template>
    <div
        class="course-card print-avoid-page-break"
        :style="useFullWidth ? 'width: 100%' : 'width: 400px;'"
        tabindex="0"
        :aria-label="`${coursePassRate.course.certificate.title} Pass Rate Report`"
        role="region"
    >
        <div
            class="col"
            align="left"
        >
            <div class="title">
                {{ coursePassRate.course.certificate.title }}
            </div>
        </div>
        <div
            class="report-container col"
        >
            <div class="row">
                <div
                    class="row-label"
                    :class="labelRowClasses"
                >
                    <div class="text">
                        FAA Exam Passes
                    </div>
                </div>
                <div
                    class="row-data"
                    :class="dataRowClasses"
                >
                    {{ coursePassRate.totalPassed }}
                </div>
            </div>
            <div class="row">
                <div
                    class="row-label"
                    :class="labelRowClasses"
                >
                    <div class="text">
                        Passed on First Attempt
                    </div>
                </div>
                <div
                    class="row-data"
                    :class="dataRowClasses"
                >
                    {{ coursePassRate.firstTryPasses }}
                </div>
            </div>
            <div class="row">
                <div
                    class="row-label"
                    :class="labelRowClasses"
                >
                    <div class="text">
                        Total Pass Rate
                    </div>
                </div>
                <div
                    class="row-data"
                    :class="dataRowClasses"
                >
                    {{ firstTryPassRate }}
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.course-card {
    text-align: left;

    .title {
        font-size: 24px;
        font-weight: 700;
        padding: 16px;
        color: var(--fsum-dark-blue);
        background: var(--fsum-light-blue);
    }
    .row-label {
        color: var(--fsum-dark-blue);
        background: var(--fsum-light-blue);
        font-weight: 700;

        .text {
            padding: 16px 0 16px 16px;
        }
    }
    .row-data {
        padding-left: 10px;
        padding-top: 16px;
        border-bottom: 1px solid var(--fsum-light-blue);
        background: var(--fsum-white);
    }
}
</style>
